import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { useQuery } from "@tanstack/react-query";

export function fetchRevendaRegiao(authToken: string, enabled?: boolean): any {
  const fetch = async (): Promise<any> => {
    const url = "api/RevendaRegiao/ListarPorFiltro";
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    const response = await instanceConexao.post(url, {}, config);
    return response?.data?.data;
  };

  const query = useQuery({
    queryFn: async () => fetch(),
    queryKey: ["fetch-revenda-regiao"],
    enabled: enabled ?? true,
    refetchOnWindowFocus: false,
  });

  return query;
}

export const postRevendaRegiaoListar = async (
  authToken: string
): Promise<any> => {
  const url = "api/RevendaRegiao/ListarPorFiltro";
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, {}, config);
  return response?.data;
};
